import React from "react"
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from "@material-ui/core"
import styles from "./index.module.scss"

const ErrorDialog = ({ open, onClose, error }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Error</DialogTitle>
      <DialogContent>
        <Typography className={styles.errorMessage}>
          {error}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ErrorDialog 